import { useEffect, type FC, type MutableRefObject } from 'react'
import { useLeadStatuses } from '../blocks/StatusListBlock/LeadStatusContext'

/** Прокидывает refreshStatuses из LeadStatusProvider во внешний ref. */
export const LeadStatusRefreshBridge: FC<{
  refreshRef: MutableRefObject<(() => void) | null>
}> = ({ refreshRef }) => {
  const { refreshStatuses } = useLeadStatuses()
  useEffect(() => {
    refreshRef.current = refreshStatuses
  }, [refreshRef, refreshStatuses])
  return null
}
